(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      // Re-measure after layout (ensures correct --header-height for main padding)
      requestAnimationFrame(() => this.setHeaderHeight());
      setTimeout(() => this.setHeaderHeight(), 100);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      /* Section wrapper can report 0 height when inner bar is fixed; use bbox of this bar too. */
      const sectionEl = this.header;
      let height = 0;
      if (sectionEl) {
        height = Math.max(
          sectionEl.offsetHeight,
          Math.round(sectionEl.getBoundingClientRect().height)
        );
      }
      height = Math.max(height, Math.round(this.getBoundingClientRect().height), 1);
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      // On mobile: force position fixed via inline styles (overrides CSS that breaks sticky/fixed)
      if (window.matchMedia('(max-width: 989px)').matches) {
        this.header.style.setProperty('position', 'fixed', 'important');
        this.header.style.setProperty('top', 'var(--announcement-banner-height, 0px)', 'important');
        this.header.style.setProperty('left', '0', 'important');
        this.header.style.setProperty('right', '0', 'important');
        this.header.style.setProperty('width', '100%', 'important');
        this.header.style.setProperty('z-index', '99999', 'important');
      } else {
        this.header.style.removeProperty('position');
        this.header.style.removeProperty('top');
        this.header.style.removeProperty('left');
        this.header.style.removeProperty('right');
        this.header.style.removeProperty('width');
        this.header.style.removeProperty('z-index');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);

      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.resizeObserver.observe(this.header);

      this.watchDropdowns();
    }

    watchDropdowns() {
      const wrapper = this.closest('.header-wrapper') || this;
      const nav = this.querySelector('.header__inline-menu');
      if (!nav) return;

      const measure = () => {
        const open = nav.querySelector('details[open] > .header__submenu.list-menu--disclosure');
        if (open) {
          const dropBottom = open.getBoundingClientRect().bottom;
          const wrapBottom = wrapper.getBoundingClientRect().bottom;
          const extend = Math.max(0, dropBottom - wrapBottom);
          wrapper.style.setProperty('--dropdown-extend', extend + 'px');
        } else {
          wrapper.style.setProperty('--dropdown-extend', '0px');
        }
      };

      const update = () => {
        requestAnimationFrame(measure);
        if (this._dropdownRO) this._dropdownRO.disconnect();
        const open = nav.querySelector('details[open] > .header__submenu.list-menu--disclosure');
        if (open) {
          this._dropdownRO = this._dropdownRO || new ResizeObserver(measure);
          this._dropdownRO.observe(open);
        }
      };

      const mo = new MutationObserver(update);
      nav.querySelectorAll('details').forEach(d =>
        mo.observe(d, { attributes: true, attributeFilter: ['open'] })
      );
      update();
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
